module.exports = __webpack_public_path__ + "img/continue-button.c158eea1.png";